exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-nolabel[data-v-1868f7fd]  .el-form-item__content{margin-left:0!important;margin-top:20px!important}.custom-height[data-v-1868f7fd]{height:calc(100% - 95px)}.detail-height[data-v-1868f7fd]{height:calc(100% - 50px)}", ""]);

// exports
